import React, { useEffect, useState } from 'react'
import { Form, Select } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { map } from 'lodash'
import { RootState } from '../reducers'
import { getJobs } from '../reducers/jobs/actions'
import { ReactComponent as ChevronIcon } from '../assets/icons/BaseMiniIcons/chevron-down-3-icon.svg'

const { Item } = Form
const { Option } = Select

type Props = {
	onValueChange: (value: ISelectedJobsOption) => void,
	jobValues: (number | null)[]
}

export interface ISelectedJobsOption {
	value: ISelectedJobOption[]
}

export interface ISelectedJobOption {
	value: number,
	label: string
}

const SelectJobsField = (props: Props) => {
	const { onValueChange, jobValues } = props
	const dispatch = useDispatch()
	const { t } = useTranslation('pages')

	const [jobSelected, setJobSelected] = useState<any>([])

	const onChange = (value: string[], option: any) => {
		onValueChange({
			value: option.map((data: any) => ({
				value: data.value,
				label: data?.children
			}))
		})
		const valuesSet = option.map((data: any) => data?.children)
		setJobSelected(valuesSet)
	}

	useEffect(() => {
		dispatch(getJobs({ limit: 1000, page: 1, queryParams: {} }))
	}, [])

	useEffect(() => {
		setJobSelected(jobValues)
	}, [jobValues])

	const jobs = useSelector((state: RootState) => state.jobs.jobs.tableData || [])
		.map((job: any) => ({
			value: job.id,
			label: job.name || job.address
		}))

	return (
		<Item>
			<Select
				onBlur={() => {}}
				className={'dropDown'}
				size={'middle'}
				onChange={onChange}
				mode={'multiple'}
				suffixIcon={<ChevronIcon width={20} height={20} />}
				showSearch
				allowClear={true}
				value={jobSelected}
				style={{ width: 200 }}
				placeholder="Vyber zákazku"
				optionFilterProp="children"
			>
				{map(jobs, (option) => (
					<Option key={option.value} value={option.value}>
						{option.label}
					</Option>
				))}
			</Select>
		</Item>
	)
}

export default React.memo(SelectJobsField)
